import React from "react"
export function Activities(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10.936 4.187c.41.11.734.38.924.725l.011-.008 1.656 2.876h2.225a.75.75 0 010 1.5l-.093-.001-2.177 3.784a.992.992 0 01.176.546h.003v4.25a.999.999 0 11-1.995 0v-1.646l-1.532 2.659a.25.25 0 11-.432-.25l1.963-3.408v-1.161l-2.253-2.23-.634 2.377a.997.997 0 01-.21.395l-2.027 3.519a.996.996 0 01-1.362.366 1.001 1.001 0 01-.366-1.366l2.088-3.626 2.203-8.24a1.496 1.496 0 011.832-1.06zm.059 2.166a.25.25 0 00-.458.188l.026.062.871 1.514-.612 2.292 2.3 2.275 1.962-3.405h-2.076a.778.778 0 01-.562-.377l-.176-.308-.01-.039-.018-.037-1.247-2.165zM7.735 5.34a1.07 1.07 0 01-.027.366l-1.134 4.467c-.138.542-.666.864-1.18.718l-.93-.263c-.514-.145-.819-.702-.68-1.245l.842-3.318.228-.806a.978.978 0 01.825-.72L6.68 4.43c.53-.056 1.002.35 1.056.909zM12.51 1c.827 0 1.497.672 1.497 1.5S13.336 4 12.509 4a1.498 1.498 0 01-1.496-1.5c0-.828.67-1.5 1.496-1.5z"
        fill="currentColor"
        id="prefix__activities"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
